module.exports = __webpack_public_path__ + "img/Enmascarar grupo 21@2x.3282423e.png";